import type { CSSObject } from '@emotion/react'
import type { TLngLat } from 'App/Map/types'
import { MapItemsCache } from 'components/GoogleMap/MapItemsCache'
import type { ReactComponentOverlayView } from 'components/GoogleMap/_utils/makeReactComponentOverlayView'
import { makeReactComponentOverlayView } from 'components/GoogleMap/_utils/makeReactComponentOverlayView'
import type { TPropertyId } from 'stores/fieldAssetStore/helperTypes'
import { IrrigationFlowMeterBadgeComponent } from './IrrigationFlowMeterBadgeComponent/IrrigationFlowMeterBadgeComponent'

export type IRRIGATION_FLOW_METER_VALUE_META = {
  propertyId: TPropertyId
  lngLat: TLngLat
  name: string
  latLng: google.maps.LatLng
  isOutOfBlock: boolean
}

export type TIrrigationFlowMeterValueTypesToPropsDictionary = Record<
  string,
  {
    children: React.ReactNode
    getContainerCSS: () => CSSObject
  }
>

export class IrrigationFlowMeterValuesCache extends MapItemsCache<
  IRRIGATION_FLOW_METER_VALUE_META,
  TIrrigationFlowMeterValueTypesToPropsDictionary,
  {
    badge: ReactComponentOverlayView<{
      meta: IRRIGATION_FLOW_METER_VALUE_META
      valueTypesToPropsDictionary: TIrrigationFlowMeterValueTypesToPropsDictionary
    }>
    polygon?: google.maps.Polygon
  }
> {
  constructor(options: { maps: typeof google.maps; map: google.maps.Map }) {
    super({
      createOverlay: (o) => {
        return {
          badge: makeReactComponentOverlayView({
            component: IrrigationFlowMeterBadgeComponent,
            latLng: o.meta.latLng,
            maps: o.maps,
            map: o.map,
          }),
        }
      },
      renderOverlay: (o) => {
        o.overlay.badge.render({ ...o, valueTypesToPropsDictionary: o.value })
      },
      hideOverlay: (o) => {
        o.overlay.badge.setMap(null)
      },
      maps: options.maps,
      map: options.map,
    })
  }
}
